export default __webpack_public_path__ + "static/media/arrow.cf255179.svg";